/*eslint-disable*/ export const messages = JSON.parse("{\"select.label.optional\":[\"Valgfri\"]}");
//# sourceMappingURL=messages.mjs.map